/** Explorer specific mixins */

export const LEFT_DRAWER_WIDTH = 430;
export const RIGHT_DRAWER_WIDTH = 330;

const mixins = {
  topNav: {
    height: 40,
  },
  sideNav: {
    width: 8 * 7,
  },
  leftSidebar: {
    width: LEFT_DRAWER_WIDTH,
  },
  rightSidebar: {
    width: RIGHT_DRAWER_WIDTH,
  },
  timeline: {
    height: 8 * 8,
  },
  statusbar: {
    height: 8 * 3,
  },
};

export default mixins;
